import { LocalizePositionService } from '@addins/core/map';
import { Component, Input, OnInit } from '@angular/core';
import { TaskTypes } from '@models/imported/SagaBase';
import { Task } from '@models/imported/SagaSchema/Task';

@Component({
  selector: 'app-task-list-item',
  templateUrl: './task-list-item.component.html',
  styleUrls: ['./task-list-item.component.scss']
})
export class TaskListItemComponent implements OnInit {
  @Input()
  task: Task;
  @Input()
  lines: string;

  isMonoMission: boolean;

  constructor(private localilzePosition: LocalizePositionService) {}

  ngOnInit() {
    this.isMonoMission = this.task.TaskType == TaskTypes.ProjectTask;
  }

  locateMission($event: MouseEvent | TouchEvent) {
    $event.stopPropagation();
    $event.preventDefault();

    this.localilzePosition.localize({
      coordinates: [this.task.location.coordinate],
      target: null
    });
  }
}
